/*
 * @Description:
 * @Author: jia.chen02
 * @Date: 2024-04-12 14:25:31
 * @LastEditors: jia.chen02
 * @LastEditTime: 2024-04-19 15:47:04
 */

import { useCityStore } from "./list";
import { useUserStore } from "./user";
import { useAlertsStore } from "./print";
import { usePaymentStore } from "./payment";
import { useN5pollingStore } from "./N5polling";
import { useFyPosStore } from "./fyPos";

export default function usePiniaStore() {
  return {
    cityListStore: useCityStore(),
    userStore: useUserStore(),
    printStore: useAlertsStore(),
    paymentStore: usePaymentStore(),
    N5pollingStore: useN5pollingStore(),
    fyPosStore: useFyPosStore(),
  };
}
